export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivace elektronické kontroly"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vkladový účet"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Číslo"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Série"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivační kód"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Šek"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["aktivovat"])}
}